import { MutableRefObject, useRef } from 'react';

/**
 * A custom hook that creates a ref for a function, and updates it on every render.
 * The new value is always the same function, but the function's context changes on every render.
 * Useful for cases when you get an old state in onClick handlers
 */
const useRefEventListener = (fn: Function): MutableRefObject<Function> => {
  const fnRef = useRef<Function>(fn);
  fnRef.current = fn;
  return fnRef;
};

export default useRefEventListener;
